import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { getSizeClass, SR_LOADING_TEXT, TERMINAL_PROMPT } from '../helper';
import '../index.less';

function TerminalLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <div ref={ref} className={cn('wg-variant-loading__terminal-container', getSizeClass(size), className)}>
      <span className={cn('wg-variant-loading__terminal-prompt', getSizeClass(size))}>{TERMINAL_PROMPT}</span>
      <div className={cn('wg-variant-loading__terminal-cursor', getSizeClass(size))} />
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const TerminalLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(TerminalLoading);
TerminalLoadingComponent.displayName = 'TerminalLoading';

export default TerminalLoadingComponent;
